import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { NotificationService } from '../notification.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public resetToken: String;
  public subscription: Subscription;
  //public errorMessage: String;
  //public successMessage: String;
  public resetData = {
          password: '',
          verifyPassword: ''
        };

  constructor(private _authservice: AuthService, private _route: ActivatedRoute,  private _notifyService: NotificationService) { }

  ngOnInit() {
    this.subscription = this._route
    .queryParams
    .subscribe(
      params => this.resetToken = params ['token']
    );    
  }

  reset(){
    //this.clearMessages();
    if(this.resetData.verifyPassword != this.resetData.password){
      this._notifyService.showError("Mot de passe de vérification incorrect", "Password", 3000)
        //this.errorMessage = 'Mot de passe de vérification incorrect';
    }else if(this.resetToken ==  undefined){
      this._notifyService.showError("Token inexistant", "Password", 3000)
      //this.errorMessage = 'Token inexistant ';
    }else{
      this._authservice.changePassword(this.resetData, this.resetToken);
      this._notifyService.showSuccess("Ton mot de passe a été changé", "Password", 6000)
      //this.successMessage = "Ton mot de passe a été changé"
    }
  }
  
  
 /* clearMessages(){
    this.errorMessage = '';
    this.successMessage = '';
  }*/


  /*resetSuccesMessage(){
    setTimeout(()=>{
      this.successMessage = '';
    }, 6000);
  }*/

  /*resetErrorMessage(){
    setTimeout(()=>{
      this.errorMessage = '';
    }, 3000);
  }*/




}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts